import React from "react";
import { TagSetOrEditCustomFieldPage } from "./TagSetOrEditCustomFieldPage";
interface EditCustomFieldPageProps {
    spaceId: string;
    customFieldId: string;
}
export function EditCustomFieldPage({ customFieldId, spaceId }: EditCustomFieldPageProps) {
    return <TagSetOrEditCustomFieldPage tagSetId={customFieldId} spaceId={spaceId}/>;
}
